// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"styles_text-gradient__1bGs7","copy":"styles_copy__2nHay","withIcon":"styles_withIcon__2DKfk","icon":"styles_icon__3WSkz"};